import React, { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import {postData, updateData, deleteItem} from './constants.js';

class ResidentGroupList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data          :[],
      resident_list :[],
      isLoading     :true,
      show          :false,
      show_content  :"edit"
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLineItemChange = this.handleLineItemChange.bind(this);
    this.addLineItem = this.addLineItem.bind(this);
    this.addResidentGroup = this.addResidentGroup.bind(this);
    this.editResidentGroup = this.editResidentGroup.bind(this);
    this.viewResidentGroup = this.viewResidentGroup.bind(this);
    this.deleteResidentGroup = this.deleteResidentGroup.bind(this);
  }

  async getResidentGroups() {
    try {
      const response = await fetch('/api/resident-groups');
      const json = await response.json();
      this.setState({ data: json.resident_groups, "resident_list":json.resident_list });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getResidentGroups();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = this.state;
    this.setState({ show: false, isLoading: true });
    var resident_list = this.state.resident_list;
    data.residents = data.resident_options.map((item,index)=>{
      var resident = resident_list.filter((e,i)=> e.lot_no+", "+e.first_name+" "+e.last_name === item)[0].id;
      return resident;
    });
    delete data.data;
    delete data.isLoading;
    if(data.id){
      updateData('/api/resident-group/'+data.id, data)
        .then((response) => {
          console.log(response);
          this.getResidentGroups();
      });
    }else{
      postData('/api/resident-group', data)
        .then((response) => {
          console.log(response);
          this.getResidentGroups();
      });
    }
  }

  handleLineItemChange(e) {
    const index = parseInt(e.target.attributes.dataindex.value);
    const value = e.target.value;
    var new_residents = this.state.resident_options;
    new_residents[index] = value;
    this.setState({
      "resident_options": new_residents
    });
  }

  addLineItem() {
    this.setState({count: this.state.count+1});
    var new_residents = this.state.resident_options;
    new_residents[this.state.count] = "";
    this.setState({"resident_options": new_residents});
    console.log("resident_options", this.state.resident_options);
  }

  addResidentGroup() {
    this.setState({
      id               :"",
      group_name       :"",
      resident_options :[""],
      status           :1,
      count            :1,
      show             :true,
      show_content     :"edit"
    });
  }

  editResidentGroup(e) {
    const id = parseInt(e.target.id);
    const resident_groups = this.state.data;
    const selectedResidentGroup = resident_groups.filter(e=> e.id === id)[0];
    this.setState(selectedResidentGroup);
    var resident_options = selectedResidentGroup.residents.map(r => {
      var selectedR = this.state.resident_list.filter(e=> e.id === r)[0];
      r = selectedR.lot_no+", "+selectedR.first_name+" "+selectedR.last_name;
      return r;
    });
    this.setState({'resident_options': resident_options});
    this.setState({count : resident_options.length, show: true, show_content:"edit" });
  }

  viewResidentGroup(e) {
    const id = parseInt(e.target.id);
    const resident_groups = this.state.data;
    const selectedResidentGroup = resident_groups.filter(e=> e.id === id)[0];
    var selectedGroupMembers = selectedResidentGroup.residents.map(e => {
      var member = this.state.resident_list.filter(r=> r.id === e)[0];
      return member;
    });
    this.setState(selectedResidentGroup);
    this.setState({group_residents: selectedGroupMembers});
    this.setState({ show: true, show_content:"view" });
  }

  deleteResidentGroup(e) {
    const id = parseInt(e.target.id);
    deleteItem("/api/resident-group/"+id)
    .then((response) => {
      console.log(response);
      this.getResidentGroups();
    });
  }

  render() {
    if(!this.state.isLoading && this.state.show_content==="edit"){
      const resident_groups = this.state.data;
      const resident_group_list = resident_groups.map((rg)=>
          <tr key={rg.id} id={rg.id}>
            <td>{rg.group_name}</td>
            <td className={rg.status?'text-success fw-bold':'fw-bold'}>{rg.status?'Active':'Inactive'}</td>
            <td>
              <div className="row">
                <div className="col">
                  <i id={rg.id} className="fas fa-info-circle text-primary action-icons" onClick={this.viewResidentGroup}></i>
                </div>
                <div className="col">
                  <i id={rg.id} className="fas fa-pencil-alt text-warning action-icons" onClick={this.editResidentGroup}></i>
                </div>
                <div className="col">
                  <i id={rg.id} className="fas fa-trash-alt text-danger action-icons" onClick={this.deleteResidentGroup}></i>
                </div>
              </div>
            </td>
          </tr>
      );
      var resident_inputs = <> </>;
      if(this.state.show && this.state.show_content==="edit"){
        var resident_list = this.state.resident_list.map((r)=>{
          return `<option>${r.lot_no+", "+r.first_name+" "+r.last_name}</option>`
        }).join("");
        document.getElementById("resident_list").innerHTML = resident_list;
        var input_arr = [];
        for(var i=0;i<this.state.count;i++){
          input_arr.push({id:i});
        }
        resident_inputs = input_arr.map((inputs, index)=>
          <div className="col-xs-12 col-md-6">
            <input key={"resident"+index} type="text" name={"resident_options"+index} dataindex={index} className="form-select form-select-sm fw-normal" value={this.state.resident_options[index]} onChange={this.handleLineItemChange} list="resident_list" />
          </div>
        );
      }
      return(
          <>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-xs-12">
                    <div className="card shadow mb-2">
                        <div className="card-header py-3">
                            <h4 className="m-0 font-weight-bold text-light">Property Owner Groups</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive resident_group-table">
                                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th>Group Name</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resident_group_list}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <button className="btn btn-primary" onClick={this.addResidentGroup}><i className="fas fa-plus"></i> New Property Owner Group</button>
                </div>
                <div className="col-lg-6 col-md-6 col-xs-12">
                  {this.state.show &&
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <h4 className="m-0 font-weight-bold text-light">Add / Edit Property Owner Group</h4>
                        </div>
                        <div className="card-body">
                            <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                                <div className="form-group">
                                    <label>Name</label>
                                    <input type="text" name="group_name" className="form-control form-control-sm" value={this.state.group_name} onChange={this.handleInputChange} required />
                                </div>
                                <div className="form-group">
                                    <label>Status</label>
                                    <select name="status" className="form-select form-select-sm" value={this.state.status} onChange={this.handleInputChange}>
                                        <option value="0">InActive</option>
                                        <option value="1">Active</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Property Owners</label>
                                    <div className="row no-gutters">
                                      {resident_inputs}
                                    </div>
                                </div>
                                <div className="text-right mb-2">
                                  <button type="button" className="btn btn-sm btn-primary" onClick={this.addLineItem}><i className="fas fa-plus"></i></button>
                                </div>
                                <div className="form-group">
                                  <input type="submit" id="resident_group-submit" className="btn btn-bg-success" value="Submit" />
                                  <button type="button" name="cancel" className="btn btn-danger ml-2" onClick={()=> this.setState({show:false})}>Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                  }
                </div>
            </div>
          </>
      );
    }
    else if(!this.state.isLoading && this.state.show && this.state.show_content==="view"){
      const residents = this.state.group_residents;
      const resident_list = residents.map((r)=>
          <tr key={r.id} id={r.id}>
            <td>{r.lot_no}</td>
            <td>{r.first_name+" "+r.last_name}</td>
            <td>{r.email}</td>
            <td className={r.status?"text-success fw-bold":"text-danger fw-bold"}>{r.status?"Active":"Inactive"}</td>
          </tr>
      );

      return(
        <>
          <div className="card shadow mb-2">
              <div className="card-header py-3">
                  <h4 className="m-0 font-weight-bold text-light">{this.state.group_name} details</h4>
              </div>
              <div className="card-body">
                  <div className="table table-responsive fee-table">
                      <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                          <thead>
                              <tr>
                                  <th>Lot No.</th>
                                  <th>Owner Name</th>
                                  <th>Email</th>
                                  <th>Status</th>
                              </tr>
                          </thead>
                          <tbody>
                              {resident_list}
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
          <button type="button" className="btn btn-dark" onClick={()=> this.setState({"show":false, "show_content":"edit"}) }> Close </button>
        </>
      )
    }
    else{
        return (<> </>);
    }
  }
}


function ResidentGroups() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <datalist id="resident_list"></datalist>
                        <ResidentGroupList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { ResidentGroups };
